import React, { useEffect, useState } from "react";
import axios from "axios";
import {  Col, Container, Row, Button } from "react-bootstrap";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import Tooltip from "react-bootstrap/Tooltip";
import ReactTost from "../../ReactTost";
import BtnLoader from "../../BtnLoader";
import { useParams } from "react-router";
import { useNavigate } from "react-router-dom";
import DeleteBot from "../Modal/DeleteBot";
import { useTranslation } from "react-i18next";


const ChatBotSetting = (props) => {
  const API_URL = process.env.REACT_APP_API_URL;
  const API_VERSION = process.env.REACT_APP_API_VERSION;
  const {t} = useTranslation();
  const [temperature, setTemperature] = useState(0);
  const [deleteModalShow, setDeleteModalShow] = useState(false);
  const { bot } = useParams();
  const [name, setName] = useState("");
  const [prompt, setPrompt] = useState("");
  const [model, setModel] = useState("");
  const [gptPrompt, setGptPrompt] = useState(`
    Information: {context}
    Question: {question}
  `);
  const [domain, setDomain] = useState("");
  const [type, setType] = useState("");
  const [message, setMessage] = useState("");
  const [visibility, setVisibility] = useState("");
  // const [messageCount, setMessageCount] = useState();
  const [scrapperName, setScrapperName] = useState();
  const [showAlert, setShowAlert] = useState(false);
  const [setLoading, setIsLoading] = useState(false);
  const [messageLimit, setMessageLimit] = useState();
  const [deleteBotId, setDeleteBotId] = useState();
  const { id } = useParams();
  const [promptBtn, setPromptBtn] = useState(false);
  const [limit, setLimit] = useState(0);
  const [seconds, setSeconds] = useState(0);
  const [getBots, setGetBots] = useState(true);
  const [activePlan, setActivePlan] = useState(false);

  const navigate=useNavigate();
  const handleTemperatureChange = (event) => {
    const newValue = parseFloat(event.target.value);
    setTemperature(newValue);
  };
  const handleResetBasePrompt = () => {
    setPrompt(
      `Act as an intelligent AI Assistant who will furnish me with detailed answers based on the provided information. If the answer is not available, respond with "Hmm, I am not sure." Never break character.`
    );
  };
  const handlePrompt = () =>{
    setPromptBtn(false);
    setPrompt("");
  }

  function updateBot(e) {
    e.preventDefault();
    setIsLoading(true);
    axios
      .patch(
        `${API_URL}/${API_VERSION}/bot/${bot}`,
        {
          name,
          settings: {
            prompt,
            model,
            temperature,
            visibility,
            domain,
            // messageCount,
            messageLimit,
            gptPrompt,
            scrapperName : scrapperName
          },
        },
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        }
      )
      .then((response) => {
        setIsLoading(false);
        setType("Success");
        setMessage("Setting updated successfully");
        showAlert(true);
      })
      .catch(() => {
        setIsLoading(false);
      });
  }
  
  const handleDeleteSuccess = () =>{
    if (getBots) {
      setGetBots(false);
      axios
      .get(`${API_URL}/${API_VERSION}/bot/user/${id}/`,{
        headers: {
          accept: "application/json",
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      }).then((response)=>{
        if(response.data.length!==0){
          let getBotId = response.data[response.data.length - 1].id;
          setGetBots(false);
          navigate(`/admin/my-bots/${id}/${getBotId}/`)
        }
        else{
          navigate(`/admin/my-bots/${id}`)
        }
       
      }).catch((err)=>{
        console.log(err)
      })
    }
  }

  useEffect(() => {
    axios
      .get(`${API_URL}/${API_VERSION}/bot/${bot}`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      })
      .then((response) => {
        console.log("get setting",response.data.settings);
        setName(response.data.name);
        setModel(response.data.settings.model);
        setDomain(response.data.settings.domain);
        setTemperature(response.data.settings.temperature);
        setMessageLimit(response.data.settings.messageLimit);
        setVisibility(response.data.settings.visibility);
        // setMessageCount(response.data.settings.messageCount);
        setScrapperName(response.data.settings.scrapperName);
      
        if (response.data.settings.gptPrompt) {
          setGptPrompt(response.data.settings.gptPrompt);
        }

        if (response.data.settings.prompt === undefined || response.data.settings.prompt === "" || response.data.settings.prompt === null) {
          setPromptBtn(true);
        }else{
          setPromptBtn(false);
          setPrompt(response.data.settings.prompt);
        }
        
      })
      .catch((err) => {
        console.log(err);
      });
  }, [bot]);

  return (
    <>
      <ReactTost
        onHide={() => {
          setShowAlert(false);
          setType("");
          setMessage("");
        }}
        alertClass={type}
        alertMessage={message}
        alertDo={showAlert}
      />
      {/* {setLoading ? ( <Loader /> ) : (  */}
        <section className="settings">
          <Container>
            <Row className="justify-content-center">
              <Col lg={12} className="mb-4">
                <div className="settings_wrap">
                  <form action="">
                    <div className="form-group">
                      <label className="form-label">
                        {t("Name")}
                        <OverlayTrigger
                          key="right"
                          placement="right"
                          overlay={<Tooltip>{t("Name info")}</Tooltip>}
                        >
                          <span className="ms-2 text-orange">
                            <i className="fa-solid fa-circle-question"></i>
                          </span>
                        </OverlayTrigger>
                      </label>
                      <input
                        className="form-control"
                        type="text"
                        name="name"
                        id="name"
                        value={name}
                        onChange={(e) => setName(e.target.value)}
                      />
                    </div>
                    <div className="form-group">
                      <label className="form-label">
                      {t("ChatGPT prompt")}
                        <OverlayTrigger
                          key="right"
                          placement="right"
                          overlay={<Tooltip>{t("ChatGPT prompt info")}</Tooltip>}
                        >
                          <span className="ms-2 text-orange">
                            <i className="fa-solid fa-circle-question"></i>
                          </span>
                        </OverlayTrigger>
                      </label>
                      <input
                        className="form-control"
                        type="text"
                        name="gptPrompt"
                        id="gptPrompt"
                        value={gptPrompt}
                        onChange={(e) => setGptPrompt(e.target.value)}
                      />
                    </div>
                    <div className="form-group">
                      {promptBtn ? (<button className="userbutton base_promt_btn" onClick={handlePrompt}>Add Base Prompt</button> ):(<div>
                      <div className="flex-column flex-sm-row d-flex align-items-sm-start align-items-md-center  align-items-lg-center justify-content-between mb-2">
                        <label className="form-label mb-0">
                          {t("Base Prompt (system message)")}
                          <OverlayTrigger
                            key="right"
                            placement="right"
                            overlay={<Tooltip>{t("Base Prompt info")}</Tooltip>}
                          >
                            <span className="ms-2 text-orange">
                              <i className="fa-solid fa-circle-question"></i>
                            </span>
                          </OverlayTrigger>
                        </label>
                        
                      </div>
                      <textarea
                        rows="3"
                        id="exampleForm.ControlTextarea1"
                        className="form-control"
                        spellcheck="false"
                        value={prompt}
                        onChange={(event) => setPrompt(event.target.value)}
                      ></textarea>
                      </div>)}
                    </div>
                    <div className="form-group">
                      <label className="form-label">
                        {t("Model")}
                        <OverlayTrigger
                          key="right"
                          placement="right"
                          overlay={<Tooltip>{t("model info")}</Tooltip>}
                        >
                          <span className="ms-2 text-orange">
                            <i className="fa-solid fa-circle-question"></i>
                          </span>
                        </OverlayTrigger>
                      </label>
                      <select
                        className="form-select"
                        aria-label="Default select example"
                        value={model}
                        onChange={(event) => setModel(event.target.value)}
                      >
                        <option selected>{t("Open this select menu")}</option>
                        <option value="gpt-3.5-turbo">{t("gpt-3.5-turbo")}</option>
                        <option value="gpt-4">{t("gpt-4")}</option>
                      </select>
                    </div>
                    <div className="form-group">
                      <label className="form-label">
                        {t("Temperature")}
                        <OverlayTrigger
                          key="right"
                          placement="right"
                          overlay={<Tooltip>{t("Temperature info")}</Tooltip>}
                        >
                          <span className="ms-2 text-orange">
                            <i className="fa-solid fa-circle-question"></i>
                          </span>
                        </OverlayTrigger>
                      </label>
                      <strong style={{ float: "right" }}>{temperature}</strong>
                      <input
                        type="range"
                        className="form-range"
                        min="0"
                        max="1"
                        step="0.1"
                        id="customRange"
                        value={temperature}
                        onChange={(e) => handleTemperatureChange(e)}
                      />
                    </div>
                    <div className="form-group">
                      <label className="form-label">
                        {t("Visibility")}
                        <OverlayTrigger
                          key="right"
                          placement="right"
                          overlay={<Tooltip>{t("Visibility info")}</Tooltip>}
                        >
                          <span className="ms-2 text-orange">
                            <i className="fa-solid fa-circle-question"></i>
                          </span>
                        </OverlayTrigger>
                      </label>
                      <select
                        className="form-select"
                        aria-label="Default select example"
                        value={visibility}
                        onChange={(event) => setVisibility(event.target.value)}
                      >
                        <option value="public">{t("public")}</option>
                        <option value="private">{t("private")}</option>
                      </select>
                    </div>
                    {visibility && visibility === "private" && (
                      <div className="form-group">
                        <label className="form-label">
                          {t("Domains")}
                          <OverlayTrigger
                            key="right"
                            placement="right"
                            overlay={<Tooltip>{t("Domains info")}</Tooltip>}
                          >
                            <span className="ms-2 text-orange">
                              <i className="fa-solid fa-circle-question"></i>
                            </span>
                          </OverlayTrigger>
                        </label>
                        <textarea
                          rows="3"
                          id="exampleForm.ControlTextarea1"
                          className="form-control"
                          spellCheck="false"
                          value={domain}
                          onChange={(event) => setDomain(event.target.value)}
                        ></textarea>
                      </div>
                    )}
                    
                    <div className="btn_group">
                      <button
                        type="button"
                        className="userbutton"
                        value="SUBMIT"
                        onClick={(e) => updateBot(e)}
                        disabled={setLoading}
                        >
                        {setLoading ? (<BtnLoader /> ) : (t('Submit'))}
                      </button>

                      <Button
                        className="btn"
                        variant=""
                        onClick={() => {
                          setDeleteModalShow(true);
                          setDeleteBotId(bot);
                        }}
                      >{t("Delete")} <i className="fa-solid fa-trash-can"></i>
                      </Button>
                    </div>
                  </form>
                </div>
              </Col>
            </Row>
          </Container>

          <DeleteBot
            show={deleteModalShow}
            deleteBotId={deleteBotId}
            onDeleteSuccess={handleDeleteSuccess}
            onHide={() => {
              setDeleteModalShow(false);
              setGetBots(true)
            }}
          />
        </section>
      {/* )} */}
    </>
  );
};

export default ChatBotSetting;
